import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SingleTabGuardService {
    private readonly STORAGE_KEY = 'dert-singleTab-lock';
    private forbidden = false;

    private router = inject(Router);

    constructor() {
        window.addEventListener('storage', this.detectOtherTab.bind(this));
        this.setSingleTab();
    }

    setSingleTab() {
        const storageValue = localStorage.getItem(this.STORAGE_KEY);


        if (storageValue && (Date.now() - parseInt(storageValue, 10) < ( 60000 /* minute */ * 30 /* 30 minutes */))) { // Should reflect JWT token expiration
            console.warn('Another tab is already open, blocking this tab.');
            this.forbidden = true;
        } else {
            localStorage.setItem(this.STORAGE_KEY, Date.now().toString());
        }
        window.addEventListener('beforeunload', () => {
            localStorage.removeItem(this.STORAGE_KEY);
            console.log('Single tab lock removed.');
        });
    }

    detectOtherTab(event: StorageEvent) {
        if (event.key === this.STORAGE_KEY && event.newValue) {
            const currentPath = this.router.url.split('?')[0].split('#')[0];
            if (currentPath === '/' || currentPath === '/dashboard') {
                return;
            }

            // another tab took over
            this.forbidden = true;
            this.router.navigate(['/forbidden'], { queryParams: { reason: 'multiple-tabs' } });
        }
    }

    isForbidden(): boolean {
        return this.forbidden;
    }
}
